import request from '../../utils/request'

// 获取档案列表信息
export const getProfilesList = (data) => {
  return request({
    url: `/api/admin/user-profiles/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}&userId=${data.userId}`,
    method: 'get'
  })
}